import React from "react"
import DfbHeadline from "../ui-kit/dfb_headline"
import DfbImage from "../ui-kit/dfb_image"
import DfbParagraph from "../ui-kit/dfb_paragraph"
import { Transformation } from "cloudinary-react"
import DfbCard from "../elements/dfb_card"
import DfbButton from "../ui-kit/dfb_button"
import Section from "./section"

const MContentSlider = (props) => {
  const withoutCategoryIcons = (teaserData) => {
    return {
      ...teaserData,
      content: {
        ...teaserData.content,
        root_categories: [],
      },
    }
  }

  return (
    <Section
      baseClass={`m-ContentSlider ${
        props.data.accordion_numbers === 1 ? "m-ContentSlider--numbered" : ""
      }`}
      data={props.data}
    >
      <div className="m-ContentSlider-top">
        <div className="m-ContentSlider-wrapper">
          <div className="m-ContentSlider-container">
            <div className="c-Headline m-ContentSlider-headline">
              {props.data.headline && (
                <DfbHeadline
                  headline={props.data.headline}
                  headline_level="h3"
                />
              )}
            </div>
            <div
              className="dfb-Slider m-ContentSlider-slider"
              data-transition="slide"
              data-indicators
              data-drag
              data-controls
              role="region"
            >
              <div className="dfb-Slider-slider">
                <ul className="dfb-Slider-slides">
                  {props.data.text_image_tiles.map((slideItem, slideIndex) => (
                    <li
                      key={`${props.data.uid}_slide_${slideIndex}`}
                      className={`m-ContentSlider-slideItem dfb-Slider-slideItem ${
                        slideIndex === 0 ? "is-current" : ""
                      }`}
                    >
                      {slideItem.image && (
                        <DfbImage
                          image={slideItem.image}
                          aspect_ratio="3:4"
                          overlay="75"
                          cover={true}
                        >
                          <Transformation
                            crop="fill"
                            gravity="faces:center"
                            width="196"
                            height="224"
                            quality="auto"
                            fetchFormat="auto"
                          />
                        </DfbImage>
                      )}

                      {slideItem.headline && (
                        <DfbHeadline
                          headline={slideItem.headline}
                          headline_level="h5"
                        />
                      )}
                    </li>
                  ))}
                </ul>
              </div>

              <ul className="dfb-Slider-controls">
                <li className="dfb-Slider-controlElement dfb-Slider-controlElement--previous">
                  <DfbButton
                    tagName="button"
                    icon_type="Dropdown Left"
                    add_class="dfb-Slider-control dfb-Slider-control--previous"
                  />
                </li>
                <li className="dfb-Slider-controlElement dfb-Slider-controlElement--next">
                  <DfbButton
                    tagName="button"
                    icon_type="Dropdown Right"
                    add_class="dfb-Slider-control dfb-Slider-control--next"
                  />
                </li>
              </ul>

              <div className="dfb-Indicators dfb-Slider-navContainer">
                {props.data.text_image_tiles.map((_, indicatorIndex) => (
                  <button
                    className={`dfb-Indicators-item ${
                      indicatorIndex === 0 ? "is-active" : ""
                    }`}
                    data-indicatoritem={indicatorIndex}
                    key={indicatorIndex}
                  >
                    <span className="dfb-Indicators-itemInner" />
                  </button>
                ))}
              </div>
            </div>
          </div>
        </div>
        <div className="dfb-Pitch dfb-Pitch--middleCircleLeftTop m-ContentSlider-playground"></div>
      </div>
      <div className="m-ContentSlider-bottom">
        <div className="m-ContentSlider-wrapper">
          <div className="m-ContentSlider-container">
            <div className="m-ContentSlider-content">
              {props.data.text_image_tiles.map((contentItem, contentIndex) => (
                <div
                  className={`m-ContentSlider-contentItem ${
                    contentIndex === 0 ? "is-current slide-in-right" : ""
                  }`}
                  key={`${props.data.uid}_content_${contentIndex}`}
                >
                  {contentItem.headline && (
                    <DfbHeadline
                      headline={contentItem.headline}
                      headline_level="h4"
                    />
                  )}
                  {contentItem.text && (
                    <DfbParagraph
                      text={contentItem.text}
                      add_class="m-ContentSlider-contentParagraph"
                    />
                  )}
                  {contentItem.collection && contentItem.collection.length > 0 && (
                    <div className="m-ContentSlider-teasers">
                      {contentItem.collection.map((teaserItem, teaserIndex) => (
                        <div
                          className="m-ContentSlider-teaserItem"
                          key={`${props.data.uid}_content_${contentIndex}_teaser_${teaserIndex}`}
                        >
                          <DfbCard data={withoutCategoryIcons(teaserItem)} />
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </Section>
  )
}

export default MContentSlider
